import { useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Megaphone, FlaskConical, ChevronLeft, Mail, UserLock, Users } from 'lucide-react';
import '../components/admin/Admin.css';
import RoleGate from '../components/RoleGate';

const ALL_ROLES = ['admin', 'write', 'read'];

const SECTIONS = [
  { path: 'campaigns', label: 'Test campaigns', icon: <Megaphone size={20} />, allow: ALL_ROLES },
  { path: 'team',      label: 'Quality Team', icon: <Users size={20} />, allow: ALL_ROLES },
  { path: 'tests-management', label: 'Test Management', icon: <FlaskConical size={20} />, allow: ALL_ROLES },
  // Read-only users can't create anything here and never own a rule, so the tab
  // has nothing useful to show them.
  { path: 'mail-forwarders', label: 'Mail Forwarders', icon: <Mail size={20} />, allow: ['admin', 'write'] },
];

function Admin() {
  const location = useLocation();
  const activeSection = location.pathname.split('/')[2] || 'campaigns';
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="application-container" style={{ overflow: 'hidden' }}>
      <div className="admin-page">
        <nav className={`admin-nav${collapsed ? ' collapsed' : ''}`}>
          <div className="admin-nav-title">
            <UserLock size={20} className="admin-nav-title-icon" />
            <span className="admin-nav-title-text">Admin</span>
          </div>
          <div className="admin-nav-divider" />
          {SECTIONS.map(s => (
            <RoleGate key={s.path} allow={s.allow}>
              <Link
                to={`/admin/${s.path}`}
                className={`admin-nav-item${activeSection === s.path ? ' active' : ''}`}
                title={collapsed ? s.label : undefined}
              >
                {s.icon}
                <span className="admin-nav-item-label">{s.label}</span>
              </Link>
            </RoleGate>
          ))}
        </nav>

        <button
          className={`admin-nav-toggle${collapsed ? ' collapsed' : ''}`}
          onClick={() => setCollapsed(c => !c)}
          aria-label="Toggle admin sidebar"
        >
          <ChevronLeft size={20} />
        </button>

        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Admin;
